import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format } from "date-fns";
import { FullLabeled, H } from "@lifepay/rc-ui-toolkit";

import styles from "./ClientInfoFull.m.scss";

function ClientInfoFull(props) {
  const { theme, client, type } = props;
  if (type === "PERSON") {
    return (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.header)}>
          <H t="h4">{"1. Основные данные"}</H>
        </div>
        <FullLabeled label={"Фамилия Имя Отчество"}>
          {client.clientName}
        </FullLabeled>
        <FullLabeled label={"Дата рождения"}>
          {format(client.birthDate, "DD.MM.YYYY")}
        </FullLabeled>
        <FullLabeled label={"Кодовое слово/дата"}>
          {client.passWord}
        </FullLabeled>
        <div className={classnames(theme.header)}>
          <H t="h4">{"2. Паспортные данные"}</H>
        </div>
        <FullLabeled label={"Тип документа"}>{client.passportDoc}</FullLabeled>
        <FullLabeled label={"Серия и номер"}>
          {`${client.passportSer} ${client.passportNum}`}
        </FullLabeled>
        <FullLabeled label={"Кем выдан"}>{client.passportPlace}</FullLabeled>
        <FullLabeled label={"Дата выдачи"}>
          {format(client.passportDate, "DD.MM.YYYY")}
        </FullLabeled>
        <FullLabeled label={"Код подразделения"}>
          {client.passportCode}
        </FullLabeled>
        <div className={classnames(theme.header)}>
          <H t="h4">{"3. Контактная информация"}</H>
        </div>
        <FullLabeled label={"Мобильный (основной)"}>{client.phone}</FullLabeled>
        <FullLabeled label={"Мобильный (доп.)"}>{client.phone1}</FullLabeled>
        <FullLabeled label={"Стационарный"}>{client.phone2}</FullLabeled>
        {/* <FullLabeled label={"Рабочий"}>{client.phone}</FullLabeled> */}
        <FullLabeled label={"Адрес регистрации"}>{client.address}</FullLabeled>
        <FullLabeled label={"Адрес проживания"}>{client.address2}</FullLabeled>
        <FullLabeled label={"Электронная почта"}>{client.email}</FullLabeled>
      </div>
    );
  }
  if (type === "COMPANY") {
    return (
      <div className={classnames(theme.wrapper)}>
        <H t="h3">{"1. Основные данные"}</H>
        <FullLabeled label={"Наименование компании"}>
          {client.companyName}
        </FullLabeled>
        <FullLabeled label={"Полное наименование компании"}>
          {client.companyFullName}
        </FullLabeled>
        <FullLabeled label={"ИНН"}>{client.inn}</FullLabeled>
      </div>
    );
  }

  return null;
}

ClientInfoFull.displayName = "ClientInfoFull";

ClientInfoFull.propTypes = {
  theme: PropTypes.object,
  client: PropTypes.object.isRequired,
  type: PropTypes.oneOf(["COMPANY", "PERSON"]).isRequired,
};

ClientInfoFull.defaultProps = {};

export default themr("@lifepay/ClientInfoFull", styles)(ClientInfoFull);



// WEBPACK FOOTER //
// ./src/components/emission/ClientInfoFull/ClientInfoFull.js